<div class="wheel-time-picker" [class.disabled]="disabled">
  <!-- Hours Stepper -->
  <div class="stepper align-items-end">
    <div class="d-flex flex-column align-items-center justify-content-center">
      <button
        type="button"
        class="stepper-btn"
        [disabled]="disabled"
        (click)="incrementHour()"
        (mousedown)="startHold(incrementHour, $event)"
        (touchstart)="startHold(incrementHour, $event)"
        (mouseup)="stopHold()"
        (mouseleave)="stopHold()"
        (touchend)="stopHold()"
        (touchcancel)="stopHold()"
        aria-label="Incrementar hora"
      >
        <img style="rotate: 180deg; width: 12px;" src="../../../assets/img/app/little-icons/caret.svg" alt="" />
      </button>
      <input
        #hourInput
        type="text"
        class="stepper-value"
        inputmode="numeric"
        maxlength="2"
        [disabled]="disabled"
        [value]="selectedHour"
        (input)="onHourInput($event.target.value)"
        (blur)="onHourBlur()"
        (keydown)="onHourKeydown($event)"
        aria-label="Hora"
      />
      <button
        type="button"
        class="stepper-btn"
        [disabled]="disabled"
        (click)="decrementHour()"
        (mousedown)="startHold(decrementHour, $event)"
        (touchstart)="startHold(decrementHour, $event)"
        (mouseup)="stopHold()"
        (mouseleave)="stopHold()"
        (touchend)="stopHold()"
        (touchcancel)="stopHold()"
        aria-label="Disminuir hora"
      >
        <img style="width: 12px;" src="../../../assets/img/app/little-icons/caret.svg" alt="" />
      </button>
    </div>
  </div>

  <!-- Separator -->
  <div class="stepper-separator">:</div>

  <!-- Minutes Stepper -->
  <div class="stepper align-items-start">
    <div class="d-flex flex-column align-items-center justify-content-center">
      <button
        type="button"
        class="stepper-btn"
        [disabled]="disabled"
        (click)="incrementMinute()"
        (mousedown)="startHold(incrementMinute, $event)"
        (touchstart)="startHold(incrementMinute, $event)"
        (mouseup)="stopHold()"
        (mouseleave)="stopHold()"
        (touchend)="stopHold()"
        (touchcancel)="stopHold()"
        aria-label="Incrementar minutos"
      >
        <img style="rotate: 180deg; width: 12px;" src="../../../assets/img/app/little-icons/caret.svg" alt="" />
      </button>
      <input
        type="text"
        class="stepper-value"
        inputmode="numeric"
        maxlength="2"
        [disabled]="disabled"
        [value]="selectedMinute"
        (input)="onMinuteInput($event.target.value)"
        (blur)="onMinuteBlur()"
        (keydown)="onMinuteKeydown($event)"
        aria-label="Minutos"
      />
      <button
        type="button"
        class="stepper-btn"
        [disabled]="disabled"
        (click)="decrementMinute()"
        (mousedown)="startHold(decrementMinute, $event)"
        (touchstart)="startHold(decrementMinute, $event)"
        (mouseup)="stopHold()"
        (mouseleave)="stopHold()"
        (touchend)="stopHold()"
        (touchcancel)="stopHold()"
        aria-label="Disminuir minutos"
      >
        <img style="width: 12px;" src="../../../assets/img/app/little-icons/caret.svg" alt="" />
      </button>
    </div>
  </div>
</div>
